import React from 'react';
import './styles.css';

const HorizontalNav = ({ link1, name1, symbol1, link2, name2, symbol2, pageName }) => {
  return (
    <span className='horWor'>
      <a title={`${name1} | Notaio a Treviso`} className='horWor' target='_self' href={link1}>{name1}</a>
      <span> {symbol1} </span>
      <a title={`${name2} | Notaio a Treviso`} className='horWor' target='_self' href={link2}>{name2}</a>
      <span> {symbol2} </span>
      <span>{pageName}</span>
    </span>
  );
}

export default HorizontalNav;
